/* eslint-disable camelcase */
import { push } from './app/routing';
import { pathFacetColours } from '../utils/product-listing/facet';

const extractColours = query => ({
  coloursInPath: query.filter(colour => pathFacetColours.includes(colour)),
  coloursInQuery: query.filter(colour => !pathFacetColours.includes(colour)),
});

const shouldRewriteUrl = (pathname, query) => {
  return (
    !pathname?.includes('shop-by') &&
    pathname?.includes('all-lingerie') &&
    query?.f_colour &&
    Array.isArray(query.f_colour)
  );
};

const cleanUpQuery = (query, coloursInQuery) => {
  const { f_colour, ...rest } = query;
  return {
    ...rest,
    ...(coloursInQuery.length ? { f_colour: coloursInQuery } : {}),
  };
};

const sanitizePathname = pathname => {
  return pathname.replace(/\/colours\/[^/]+/, '').replace(/\/$/, '');
};

const buildColourPathSegment = coloursInPath => {
  return coloursInPath.length ? `/colours/${coloursInPath.join('+')}` : '';
};

export const updateQueryParams = query => (dispatch, getState) => {
  const { pathname } = getState().app.routing;

  let updatedPathname = pathname;
  let sanitizedQuery = query;

  if (shouldRewriteUrl(pathname, query)) {
    const { coloursInPath, coloursInQuery } = extractColours(query.f_colour);

    updatedPathname =
      sanitizePathname(pathname) + buildColourPathSegment(coloursInPath);

    sanitizedQuery = cleanUpQuery(query, coloursInQuery);
  } else {
    updatedPathname = pathname
      .replace(/\/colours\/[^/]+\/?/, '/')
      .replace(/\/\/+/g, '/');
  }

  const location =
    typeof query === 'string'
      ? updatedPathname + query
      : {
          pathname: updatedPathname,
          query: sanitizedQuery,
        };

  return dispatch(push(location));
};

export default {
  updateQueryParams,
};
